import React from 'react'

export const SavingsIcon = () => {
  return (
    <svg
      width='31'
      height='49'
      viewBox='0 0 31 49'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H27C29.2091 0 31 1.79086 31 4V36.8781C31 37.5173 30.6945 38.118 30.1778 38.4945L18.0773 47.312C16.6924 48.3212 14.8186 48.3361 13.4178 47.3491L0.848069 38.4929C0.31633 38.1183 0 37.5084 0 36.858V4Z'
        fill='#2D996E'
      />
      <circle cx='15.5' cy='22.5' r='9.5' fill='white' />
      <path
        d='M17.5964 20.1243C17.514 19.9647 17.4111 19.8206 17.2915 19.6971C16.9269 19.3301 16.458 19.1355 15.9769 19.1516C15.5186 19.1287 15.0658 19.2752 14.6829 19.5704C14.5052 19.7069 14.3598 19.8936 14.2601 20.1131C14.1605 20.3326 14.1098 20.5779 14.1128 20.8263C14.1015 21.0607 14.1397 21.2948 14.2243 21.5079C14.3089 21.721 14.4371 21.9064 14.5977 22.0478C14.9821 22.3475 15.4098 22.5636 15.86 22.6858L15.8894 22.696C16.3449 22.8193 16.7763 23.0417 17.1612 23.3516C17.3284 23.4986 17.4622 23.6912 17.5509 23.9125C17.6396 24.1338 17.6806 24.3772 17.6703 24.6212C17.6749 24.879 17.6232 25.1338 17.5203 25.3619C17.4174 25.59 17.2665 25.7837 17.0819 25.9251C16.6939 26.2244 16.2351 26.3738 15.7704 26.3522C15.2842 26.3614 14.8064 26.2038 14.396 25.8991C14.2379 25.7799 14.103 25.6232 14 25.4393M15.9512 18L15.9447 19.0716M15.9 26.385L15.8935 27.4566'
        stroke='#2D996E'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
